import {IconCheck} from "../Icons/IconCheck";
import {IconError} from "../Icons/IconError";
import {IconDoubleCheck} from "../Icons/IconDoubleCheck";

export const MessageStatus = {
    'pending': null,
    'scheduled': null,
    'sent': <IconCheck style={{color: 'rgb(164 164 164)'}} />,
    'failed': <IconError style={{width: '14px', height: '14px'}} />,
    'canceled': <IconError style={{width: '14px', height: '14px'}} />,
    'delivered': <IconDoubleCheck style={{color: 'rgb(164 164 164)'}} />,
    'seen': <IconDoubleCheck style={{color: 'rgb(0, 140, 255)'}} />,
}

export const MessageStatusHint = {
    'pending': null,
    'scheduled': null,
    'sent': {type: 'info', text: 'Отправлено'},
    'failed': {type: 'error', text: 'Не отправлено'},
    'canceled': {type: 'error', text: 'Не отправлено'},
    'delivered': {type: 'info', text: 'Доставлено'},
    'seen': {type: 'info', text: 'Прочитано'},
}